import { Sizes, Placement, Variant } from '../enum-types.ts';

export const BadgeTags = {
   Badge: 'atlantis-badge',
};

export interface AtlBadgeProps {
   label?: string;
   hiddenLabel?: string;
   variant?: Variant;
   size?: Sizes;
   placement?: Placement;
   as?: BadgeAs;
   detached: boolean;
   wrapperClass?: string;
}

export enum BadgeAs {
   Normal = 'Normal',
   Dot = 'Dot',
   Pill = 'Pill',
}

export const BadgeEnums = {
   Sizes,
   Placement,
   Variant,
   BadgeAs,
} as const;
